export const cnTopbarGroupCall = (className = '') => `pinned-group-call${className}`;
